import React, { useState } from "react";
import RequestService from "../../services/request.service";


import { Button, Modal, Table, Form, Row, Col, Dropdown, DropdownButton } from 'react-bootstrap'


import Pagination from "../../services/Pagination";


import { toast } from 'react-toastify'

import AuthService from "../../features/auth/auth.service";


import { Formik } from 'formik';
import * as yup from 'yup';



import moment from 'moment'


import Dialog from '../../services/Dialogs'


import ModalNuevoAsesor from './Modales/ModalNuevoAsesor'
import ModalEditarAsesor from './Modales/ModalEditarAsesor'


import ModalNuevoGerente from './Modales/ModalNuevoGerente'
import ModalEditarUsuario from './Modales/ModalEditarUsuario'


import ModalNuevoDirectorComercial from './Modales/ModalNuevoDirectorComercial'


import ModalResetPasswordUsuario from './ModalResetPasswordUsuario'



import ModalListaAsesoresGerente from './ModalListaAsesoresGerente'



import ModalSucursalesDirectorComercial from './ModalSucursalesDirectorComercial'

import ModalEditarDirectorComercial from './Modales/ModalEditarDirectorComercial'



import ModalCambiarUsername from './ModalCambiarUsername'


import ModalContratoEmpleado from './ModalContratoEmpleado'


import ModalNuevoAdministrativo from './Modales/ModalNuevoAdministrativo'


import ModalMovimientoAdministrativo from './ModalMovimientoAdministrativo'


import ModalAsesorAsignarGerente from './ModalAsesorAsignarGerente'


import ModalAuditoriaMovimientosPersonal from './ModalAuditoriaMovimientosPersonal'


import ModalFaltasRetardos from './ModalFaltasRetardos'




import ModalNuevoDirector from './ModalNuevoDirector'



import ModalNuevoUsuarioContabilidad from './ModalNuevoUsuarioContabilidad'



import ModalNuevoSupervisor from './ModalNuevoSupervisor'
import ModalAsignarSupervisorAsesor from './ModalAsignarSupervisorAsesor'
import ModalSupervisorListaSupervisados from './ModalSupervisorListaSupervisados'


import '../../rol_classes.scss'



import { labelPrivilegio } from '../../services/funcionesPublicas'


const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u


const FormateaNumero = (n:string) => n.substr(0,3) + '-' + n.substr(3,3) + '-' + n.substr(6,4) 



const RecursosHumanos = () =>{

    const dialog = new Dialog();

  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 30
  const [currentPage, setCurrentPage] = useState(1);

  const [ pagina, setPagina ] = useState(0)
  const [ text_busqueda, setTextoBusqueda ] = useState('')


  const [ cargando_, setCargando ] = useState( true )

  const skull = {
    years: [],
    meses: [],
    tramites_atender: []
  }

  const [ reporte, setReporte ] = useState<any>([])

  
      const currentUser  = AuthService.getCurrentUser();

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint('recursos_humanos/'+arreglo_roles.join(',')+'/lista_personal?where='+text_busqueda+'&skip='+skip+'&sessionsPerPage='+sessionsPerPage)
      // console.log(response.data)
      // setCurrentPage(page)
      // setTotalResulados(response.data.totalCount)
      setCounter(response.data.totalCount)
      // setPaginas(response.data.numberPages)

      setReporte(response.data.results)
      setCargando(false)
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }


  const busquedaEtiquetas = async () =>{
    // setPagina(0)
    cargarMiReporte(0)
    setCurrentPage(0)
  }

  React.useEffect(() => {
    cargarMiReporte(0)
  }, []);




  const [ modalNuevoGerente, setModalNuevoGerente] = useState<boolean>(false)
  const onHideModalNuevoGerente = () =>{
    setModalNuevoGerente(false)
  }

  const abrirModalNuevoGerente = () =>{
     setModalNuevoGerente(true) 
  }






  const [ modalNuevoAsesor, setModalNuevoAsesor] = useState<boolean>(false)
  const onHideModalNuevoAsesor = () =>{
    setModalNuevoAsesor(false)
  }

  const abrirModalNuevoAsesor = () =>{
     setModalNuevoAsesor(true) 
  }



  const [ modalEditarAsesor, setModalEditarAsesor] = useState<boolean>(false)
  const onHideModalEditarAsesor = () =>{
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalEditarAsesor(false)

  }

  const [ asesor_editar, setAsesorEditar ] = useState<any>({})
  const abrirModalEditarAsesor = (asesor:any) =>{
     setAsesorEditar(asesor)
     // console.log(asesor)
     setModalEditarAsesor(true) 
  }




  const [ modalEditarGerente, setModalEditarGerente] = useState<boolean>(false)
  const onHideModalEditarGerente = () =>{
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalEditarGerente(false)

  }

  const [ gerente_editar, setGerenteEditar ] = useState<any>({})
  const abrirModalEditarGerente = (gerente:any) =>{
     setGerenteEditar(gerente)
     // console.log(gerente)
     setModalEditarGerente(true) 
  }



  const [ arreglo_roles, setArregloRoles ] = useState<any>([false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, true, true, true])

  const todos = () =>{
    setArregloRoles([true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true])
  }
  const ninguno = () =>{
    setArregloRoles([false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false])
  }





  const activarUsuario = async ( uuid_usuario:string, index:number, estatus:boolean ) =>{

    let REPORTE_ORIGINAL = [...reporte]

    try{

      let res = await RequestService.update('usuarios/actualizar_estatus_acceso/'+uuid_usuario, { estatus : !estatus })
      if(res.data){
        REPORTE_ORIGINAL[index].activo = !estatus  
        setReporte(REPORTE_ORIGINAL)    
        toast.warning('Cambiamos el estatus de este usuario')
      }
      else{
        REPORTE_ORIGINAL[index].activo = estatus  
        setReporte(REPORTE_ORIGINAL)    
      }

    }
    catch(e){
      REPORTE_ORIGINAL[index].activo = estatus  
      setReporte(REPORTE_ORIGINAL)
      toast.error('Tuvimos problemas al actualizar el estatus de acceso del usuario')
    }

    

  }




  const [ show_ModalResetPasswordUsuario, setModalResetPasswordUsuario ] = useState<boolean>(false)
  const handleShow_ModalResetPasswordUsuario = (usuario:any) => {
     setAsesorEditar(usuario)
    setModalResetPasswordUsuario(true)
  }
  const handleClose_ModalResetPasswordUsuario = () => {
    setModalResetPasswordUsuario(false)
  }





  const [ show_ModalListaAsesoresGerente, setModalListaAsesoresGerente ] = useState<boolean>(false)
  const handleShow_ModalListaAsesoresGerente = (gerente:any) => {
     setAsesorEditar(gerente)
    setModalListaAsesoresGerente(true)
  }
  const handleClose_ModalListaAsesoresGerente = () => {
    setModalListaAsesoresGerente(false)
  }



  const [ modalNuevoDirectorComercial, setModalNuevoDirectorComercial ] = useState<boolean>(false)
  const handleShow_ModalNuevoDirectorComercial = () => {
     setModalNuevoDirectorComercial(true)
  }
  const onHideModalNuevoDirectorComercial = () => {
    setModalNuevoDirectorComercial(false)
  }



  const [ show_ModalSucursalesDirectorComercial, setModalSucursalesDirectorComercial ] = useState<boolean>(false)
  const handleShow_ModalSucursalesDirectorComercial = (usuario:any) => {
     setAsesorEditar(usuario)
    setModalSucursalesDirectorComercial(true)
  }
  const handleClose_ModalSucursalesDirectorComercial = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalSucursalesDirectorComercial(false)
  }



  const [ show_ModalEditarDirectorComercial, setModalEditarDirectorComercial ] = useState<boolean>(false)
  const handleShow_ModalEditarDirectorComercial = (usuario:any) => {
     setAsesorEditar(usuario)
    setModalEditarDirectorComercial(true)
  }
  const handleClose_ModalEditarDirectorComercial = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalEditarDirectorComercial(false)
  }



  const [ show_ModalCambiarUsername, setModalCambiarUsername ] = useState<boolean>(false)
  const handleShow_ModalCambiarUsername = (usuario:any) => {
     setAsesorEditar(usuario)
    setModalCambiarUsername(true)
  }
  const handleClose_ModalCambiarUsername = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalCambiarUsername(false)
  }


  const promoverAsesorAGerente = async(uuid_usuario:string,event:any)=>{
  try{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: 'PROMOCIÓN',
        target: event.target,
        template: `¿Estas seguro de Promover a este Asesor como Gerente?`
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        // setSeEnvio(true)
      // console.log('lo que se envia es:', nuevo_usuario)
        let res_nuevo_usuario = await RequestService.update('promocion/asesor_gerente/'+uuid_usuario, {})

        if(res_nuevo_usuario){
          toast.success('Tu registro se actualizó correctamente, ahora puede acceder a la plataforma Gesti+ CRM')
          setTimeout(()=>{
            cargarMiReporte(currentPage===0?0:currentPage-1)
          },0)
        }
        else{
          toast.error('Error al promover usuario en el servidor')
        }  
        
      }
    }
    catch(e:any){
      toast.error(e.response.data)
    }
  }



  const degradarGerenteAsesor = async(uuid_usuario:string,event:any)=>{
  try{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: 'DESCENSO',
        target: event.target,
        template: `¿Estas seguro de Degradar a este Gerente como Asesor?`
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        // setSeEnvio(true)
      // console.log('lo que se envia es:', nuevo_usuario)
        let res_nuevo_usuario = await RequestService.update('degradar/gerente_asesor/'+uuid_usuario, {})

        if(res_nuevo_usuario){
          toast.success('Tu registro se actualizó correctamente, ahora puede acceder a la plataforma Gesti+ CRM')
          setTimeout(()=>{
            cargarMiReporte(currentPage===0?0:currentPage-1)
          },0)
        }
        else{
          toast.error('Error al promover usuario en el servidor')
        }  
        
      }
    }
    catch(e:any){
      toast.error(e.response.data)
    }
  }




  const [ show_ModalContratoEmpleado, setModalContratoEmpleado ] = useState<boolean>(false)
  const handleShow_ModalContratoEmpleado = (empleado:any) => {
     setAsesorEditar(empleado)
    setModalContratoEmpleado(true)
  }
  const handleClose_ModalContratoEmpleado = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalContratoEmpleado(false)
  }





  const [ show_ModalNuevoAdministrativo, setModalNuevoAdministrativo ] = useState<boolean>(false)
  const handleShow_ModalNuevoAdministrativo = () => {
    setModalNuevoAdministrativo(true)
  }
  const handleClose_ModalNuevoAdministrativo = () => {
    setModalNuevoAdministrativo(false)
  }


const [ envio_server, setSeEnvio ] = useState<boolean>(false)
const cambiarRol = async (event:any,usuario:any,rol:string) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `recursos_humanos/cambiar_rol/${usuario.uuid}` , { rol : rol })

        if(res_){
          toast.success('Se cambio el rol de este usuario')
          // setTimeout(()=>{
          //   cargar()
            cargarMiReporte(currentPage===0?0:currentPage-1)
          // },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}




  const [ show_ModalMovimientoAdministrativo, setModalMovimientoAdministrativo ] = useState<boolean>(false)
  const handleShow_ModalMovimientoAdministrativo = (empleado:any) => {
     setAsesorEditar(empleado)
    setModalMovimientoAdministrativo(true)
  }
  const handleClose_ModalMovimientoAdministrativo = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalMovimientoAdministrativo(false)
  }




  const [ show_ModalAsesorAsignarGerente, setModalAsesorAsignarGerente ] = useState<boolean>(false)
  const handleShow_ModalAsesorAsignarGerente = (empleado:any) => {
     setAsesorEditar(empleado)
    setModalAsesorAsignarGerente(true)
  }
  const handleClose_ModalAsesorAsignarGerente = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalAsesorAsignarGerente(false)
  }



  const [ show_ModalAuditoriaMovimientosPersonal, setModalAuditoriaMovimientosPersonal ] = useState<boolean>(false)
  const handleShow_ModalAuditoriaMovimientosPersonal = (empleado:any) => {
     setAsesorEditar(empleado)
    setModalAuditoriaMovimientosPersonal(true)
  }
  const handleClose_ModalAuditoriaMovimientosPersonal = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalAuditoriaMovimientosPersonal(false)
  }





  const [ show_ModalFaltasRetardos, setModalFaltasRetardos ] = useState<boolean>(false)
  const handleShow_ModalFaltasRetardos = (empleado:any) => {
     setAsesorEditar(empleado)
    setModalFaltasRetardos(true)
  }
  const handleClose_ModalFaltasRetardos = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalFaltasRetardos(false)
  }





  const [ show_ModalNuevoUsuarioContabilidad, setModalNuevoUsuarioContabilidad ] = useState<boolean>(false)
  const [ tipo_contabilidad, setTipoContabilidad ] = useState<string>('')
  const handleShow_ModalNuevoUsuarioContabilidad = (tipo_contabilidad:string) => {
    setTipoContabilidad(tipo_contabilidad)
    setModalNuevoUsuarioContabilidad(true)
  }
  const handleClose_ModalNuevoUsuarioContabilidad = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalNuevoUsuarioContabilidad(false)
  }





  const [ show_ModalAsignarSupervisorAsesor, setModalAsignarSupervisorAsesor ] = useState<boolean>(false)
  const handleShow_ModalAsignarSupervisorAsesor = (asesor:any) => {
     setAsesorEditar(asesor)
    setModalAsignarSupervisorAsesor(true)
  }
  const handleClose_ModalAsignarSupervisorAsesor = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalAsignarSupervisorAsesor(false)
  }





  const [ show_ModalNuevoSupervisor, setModalNuevoSupervisor ] = useState<boolean>(false)
  const handleShow_ModalNuevoSupervisor = () => {
    setModalNuevoSupervisor(true)
  }
  const handleClose_ModalNuevoSupervisor = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalNuevoSupervisor(false)
  }



  const [ show_ModalSupervisorListaSupervisados, setModalSupervisorListaSupervisados ] = useState<boolean>(false)
  const handleShow_ModalSupervisorListaSupervisados = (asesor:any) => {
     setAsesorEditar(asesor)
    setModalSupervisorListaSupervisados(true)
  }
  const handleClose_ModalSupervisorListaSupervisados = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalSupervisorListaSupervisados(false)
  }




  const [ show_ModalNuevoDirector, setModalNuevoDirector ] = useState<boolean>(false)
  const handleShow_ModalNuevoDirector = () => {
    setModalNuevoDirector(true)
  }
  const handleClose_ModalNuevoDirector = () => {
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setModalNuevoDirector(false)
  }





      return (
             
          <>



            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">






                  <h2>Listado de Personal</h2>
                  <hr />



                              <div className="">
                                <label className="form-label">Búsqueda</label>
                                <div className="input-group mb-3">
                                  <input type="text" className="form-control" onKeyDown={(e)=>{if(e.keyCode === 13){ busquedaEtiquetas() }}} placeholder="" value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                                  <button onClick={busquedaEtiquetas} className="btn btn-default" type="button" id="button-addon2"><i className="fa fa-search" /></button>
                                </div>
                              </div>


                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <Button onClick={handleShow_ModalNuevoAdministrativo} size="sm" variant="link">Alta Administrativo</Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={abrirModalNuevoAsesor} size="sm" variant="link">Nuevo Asesor</Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={abrirModalNuevoGerente} size="sm" variant="link">Nuevo Gerente / Asistente</Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={handleShow_ModalNuevoDirector} size="sm" variant="link">Nuevo Director </Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={handleShow_ModalNuevoDirectorComercial} size="sm" variant="link">Nuevo Director Comercial</Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={(e:any)=>{handleShow_ModalNuevoUsuarioContabilidad('administrador')}} size="sm" variant="link">Nuevo Contabilidad</Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={(e:any)=>{handleShow_ModalNuevoUsuarioContabilidad('captura')}} size="sm" variant="link">Nuevo Captura de Contabilidad</Button>
                                </li>
                                <li className="list-inline-item">
                                  <Button onClick={handleShow_ModalNuevoSupervisor} size="sm" variant="link">Nuevo Supervisor</Button>
                                </li>
                              </ul>




                                      <div key={`inline-checkbox`} className="mb-3">

                                      {
                                        // JSON.stringify(arreglo_estatus)
                                      }


                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_ADMIN') } checked={arreglo_roles[0]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[0] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_0`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_GERENTE') } checked={arreglo_roles[1]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[1] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_1`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_DEPARTAMENTO') } checked={arreglo_roles[2]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[2] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_2`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_ASESOR') } checked={arreglo_roles[3]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[3] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_3`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_ASISTENTE') } checked={arreglo_roles[4]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[4] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_4`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_ASEGURADORA') } checked={arreglo_roles[5]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[5] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_5`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_VERIFICADOR_TELEFONICO') } checked={arreglo_roles[6]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[6] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_6`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_ADMIN_MESA') } checked={arreglo_roles[7]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[7] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_7`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_RECURSOS_HUMANOS') } checked={arreglo_roles[8]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[8] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_8`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_ASESOR_BASE') } checked={arreglo_roles[9]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[9] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_9`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_GERENTE_JR') } checked={arreglo_roles[10]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[10] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_10`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_GERENTE_CONSOLIDADO') } checked={arreglo_roles[11]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[11] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_11`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_DIRECTOR_COMERCIAL') } checked={arreglo_roles[12]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[12] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_12`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_CONTABILIDAD') } checked={arreglo_roles[13]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[13] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_13`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_SUPERVISOR') } checked={arreglo_roles[14]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[14] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_14`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_DIRECTOR_EXPANSION') } checked={arreglo_roles[15]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[15] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_15`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_DIRECTOR_GENERAL') } checked={arreglo_roles[16]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[16] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_16`} />
                                    <Form.Check inline name="group1" type="checkbox" label={ labelPrivilegio('ROLE_FINANZAS_CAPTURAS') } checked={arreglo_roles[17]} onChange={(e)=>{ var ne = [...arreglo_roles]; ne[17] = e.target.checked;  setArregloRoles(ne);}} id={`opciones_17`} />



                                    <ul className="list-inline">
                                      <li className="list-inline-item"><small className="cursor" onClick={()=>{todos()}}>Todos</small> / <small className="cursor" onClick={()=>{ninguno()}}>Ninguno</small></li>
                                      
                                    </ul>


                                        </div>



                          {  (!cargando_) && (

                              <>



                                      



                                     {
                                       reporte.length > 0 && (

                                         <>


                                         <h5>Usuarios del Sistema</h5>


                                          <Table responsive="lg">
                                            <thead style={{fontSize:12}}>
                                              <tr>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col">CURP</th>
                                                <th scope="col">Ingreso</th>
                                                <th scope="col" colSpan={1}>Nombre</th>
                                                <th scope="col" colSpan={1}>Sucursal </th>
                                                <th scope="col" colSpan={1}>Puesto / Departamento </th>
                                                <th scope="col">Usuario</th>
                                                <th scope="col">Email / Celular</th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {
                                                reporte.map( (usuario:any,indice:number) =>
                                                    <tr key={ indice } style={{fontSize:12}} className={ !usuario.activo ? 'table-warning' : '' }>
                                                      <td className={ 'v text-left ' + usuario.rol } style={{"width":"12px"}}>
                                                          
                                                      </td>
                                                    <td className="v text-center" style={{"width":"30px"}}>
                                                      <input type="checkbox" checked={usuario.activo} onChange={()=>{activarUsuario(usuario.uuid,indice,usuario.activo)}} />
                                                    </td>
                                                      <td className="v">
                                                        {labelPrivilegio(usuario.rol)} {' '} 

                                                        {
                                                          ['ROLE_ASESOR_BASE','ROLE_ASESOR'].indexOf(usuario.rol) > -1 && (
                                                            <i onClick={(e:any)=>{promoverAsesorAGerente(usuario.uuid,e)}} className="fa fa-level-up cursor" />
                                                          )
                                                        }

                                                        {
                                                          ['ROLE_GERENTE','ROLE_GERENTE_JR'].indexOf(usuario.rol) > -1 && (
                                                            <i onClick={(e:any)=>{degradarGerenteAsesor(usuario.uuid,e)}} className="fa fa-level-down cursor" />
                                                          )
                                                        }

                                                      </td>
                                                      <td className="v text-left" style={{"width":"160px"}}>
                                                        <p className="nm">
                                                          <b>{usuario.curp}</b>
                                                          <br />
                                                          <small>{usuario.rfc}</small>
                                                        </p>
                                                      </td>

                                                                    {
                                                                      ['ROLE_ASESOR_BASE','ROLE_ASESOR','ROLE_GERENTE_JR','ROLE_GERENTE'].indexOf(usuario.rol) < 0 && (
                                                                          <td className="v text-left cursor" onClick={(e:any)=>{handleShow_ModalContratoEmpleado(usuario)}} style={{"width":"100px"}}>
                                                                            <small>{usuario.fecha_ingreso}</small>
                                                                            <br/>
                                                                            <small>{moment(usuario.fecha_ingreso).from(moment())}</small>
                                                                          </td>
                                                                      )
                                                                    }

                                                                    {
                                                                      ['ROLE_ASESOR_BASE','ROLE_ASESOR','ROLE_GERENTE_JR','ROLE_GERENTE'].indexOf(usuario.rol) > -1 && (
                                                                          <td className="v text-left " style={{"width":"100px"}}>
                                                                            <small>{usuario.fecha_ingreso}</small>
                                                                            <br/>
                                                                            <small>{moment(usuario.fecha_ingreso).from(moment())}</small>
                                                                          </td>
                                                                      )
                                                                    }




                                                      <td className="v text-left" >
                                                        <p className="nm">
                                                            <b>{usuario.nombres} </b>
                                                            <br/>
                                                            <small>{usuario.paterno} {usuario.materno}</small> {' '}
                                                            {
                                                              usuario.idsupervisor && (<i title="Tiene Supervisor" className="fa fa-user-secret" />)
                                                            }
                                                        </p>
                                                      </td>



                                                                    {
                                                                      ['ROLE_ASESOR_BASE','ROLE_ASESOR','ROLE_GERENTE_JR','ROLE_GERENTE','ROLE_DIRECTOR_COMERCIAL','ROLE_ASISTENTE','ROLE_SUPERVISOR'].indexOf(usuario.rol) < 0 && (
                                                                          <>
                                                                            <td className="v text-left cursor" onClick={()=>{handleShow_ModalMovimientoAdministrativo(usuario)}} style={{"width":"180px"}}>
                                                                                  {
                                                                                    // JSON.stringify(usuario.idsucursal.nombre_sucursal)
                                                                                    usuario.idsucursal && (
                                                                                        <>
                                                                                          <p className="nm">{usuario.idsucursal.nombre_sucursal}</p>
                                                                                          <small>{usuario.idsucursal.idestado.estado}</small>
                                                                                        </>
                                                                                    )
                                                                                  }
                                                                            </td>
                                                                            <td className="v text-left cursor" onClick={()=>{handleShow_ModalMovimientoAdministrativo(usuario)}} style={{"width":"180px"}}>
                                                                                {usuario.idpuesto&&(<p className="nm">{usuario.idpuesto.puesto}</p>)}
                                                                                {usuario.iddepartamento&&(<small>{usuario.iddepartamento.departamento}</small>)}
                                                                            </td>
                                                                          </>
                                                                      )
                                                                    }

                                                                    {
                                                                      ['ROLE_ASESOR_BASE','ROLE_ASESOR','ROLE_GERENTE_JR','ROLE_GERENTE','ROLE_DIRECTOR_COMERCIAL','ROLE_ASISTENTE','ROLE_SUPERVISOR'].indexOf(usuario.rol) > -1 && (
                                                                          <>
                                                                            <td className="v text-left cursor" onClick={()=>{handleShow_ModalMovimientoAdministrativo(usuario)}} style={{"width":"180px"}}>
                                                                                  {
                                                                                    // JSON.stringify(usuario.idsucursal.nombre_sucursal)
                                                                                    usuario.idsucursal && (
                                                                                        <>
                                                                                          <p className="nm">{usuario.idsucursal.nombre_sucursal}</p>
                                                                                          <small>{usuario.idsucursal.idestado.estado}</small>
                                                                                        </>
                                                                                    )
                                                                                  }
                                                                            </td>
                                                                            <td className="v text-left " style={{"width":"180px"}}>
                                                                            </td>
                                                                          </>
                                                                      )
                                                                    }





                                                      <td className="v text-left" style={{"width":"140px"}}>
                                                        {usuario.username} <i className="fa fa-edit" onClick={()=>{handleShow_ModalCambiarUsername(usuario)}} />
                                                      </td>

                                                      <td className="v text-right" style={{"width":"100px"}}>
                                                        <p className="nm"><small>{FormateaNumero(usuario.celular)}</small></p>
                                                        <small>{usuario.email}</small>
                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>
                                                            <Button  variant="warning" onClick={()=>{handleShow_ModalResetPasswordUsuario(usuario)}} size="sm"><i className="fa fa-key"/></Button>
                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>
                                                            
                                                        {
                                                          ['ROLE_ASESOR','ROLE_ASESOR_BASE'].indexOf(usuario.rol) > -1 && (
                                                            <Button disabled={!usuario.activo} onClick={()=>{handleShow_ModalAsesorAsignarGerente(usuario)}} variant={`${ (!usuario.idgerente ? 'warning' : 'primary' ) }`} size="sm"><i className="fa fa-user"/></Button>
                                                          )
                                                        }

                                                        {
                                                          ['ROLE_GERENTE','ROLE_GERENTE_JR','ROLE_GERENTE_CONSOLIDADO'].indexOf(usuario.rol) > -1 && (
                                                            <Button disabled={!usuario.activo} onClick={()=>{handleShow_ModalListaAsesoresGerente(usuario)}} variant={`${ usuario.numero_asesores > 0 ? 'primary' : 'warning' }`} size="sm"><i className="fa fa-users"/></Button>
                                                          )
                                                        }


                                                        {
                                                          ['ROLE_DIRECTOR_COMERCIAL'].indexOf(usuario.rol) > -1 && (
                                                            <Button disabled={!usuario.activo} onClick={()=>{handleShow_ModalSucursalesDirectorComercial(usuario)}} size="sm"><i className="fa fa-building"/></Button>
                                                          )
                                                        }

                                                        {
                                                          ['ROLE_SUPERVISOR'].indexOf(usuario.rol) > -1 && (
                                                            <Button disabled={!usuario.activo} onClick={()=>{handleShow_ModalSupervisorListaSupervisados(usuario)}} size="sm"><i className="fa fa-users"/></Button>
                                                          )
                                                        }

                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>

                                                        {
                                                          usuario.activo && (
                                                                <Dropdown >
                                                                  <Dropdown.Toggle variant="success" size="sm" id="dropdown-basic">
                                                                    <i className="fa fa-gear"/>
                                                                  </Dropdown.Toggle>
                                                                  <Dropdown.Menu>

                                                                                <Dropdown.Item onClick={()=>{abrirModalEditarGerente(usuario)}}> Editar Información <i className="fa fa-pencil"/></Dropdown.Item>


                                                                            {
                                                                              ['ROLE_ASESOR','ROLE_ASESOR_BASE'].indexOf(usuario.rol) > -1 && (
                                                                                <Dropdown.Item onClick={(e:any)=>{handleShow_ModalAsignarSupervisorAsesor(usuario)}}> Supervisor <i className="fa fa-eye" /> </Dropdown.Item>
                                                                              )
                                                                            }


                                                                            {
                                                                              // ['ROLE_ASESOR'].indexOf(usuario.rol) > -1 && (
                                                                              //   <Dropdown.Item onClick={(e:any)=>{cambiarRol(e,usuario,'ROLE_ASESOR_BASE')}}> VOLVER ASESOR BASE </Dropdown.Item>
                                                                              // )
                                                                            }

                                                                            {
                                                                              // ['ROLE_ASESOR_BASE'].indexOf(usuario.rol) > -1 && (
                                                                              //   <Dropdown.Item onClick={(e:any)=>{cambiarRol(e,usuario,'ROLE_ASESOR')}}> VOLVER ASESOR NORMAL </Dropdown.Item>
                                                                              // )
                                                                            }

                                                                            {
                                                                              ['ROLE_GERENTE'].indexOf(usuario.rol) > -1 && (
                                                                                <Dropdown.Item onClick={(e:any)=>{cambiarRol(e,usuario,'ROLE_GERENTE_JR')}}> VOLVER GERENTE JR </Dropdown.Item>
                                                                              )
                                                                            }

                                                                            {
                                                                              ['ROLE_GERENTE_JR'].indexOf(usuario.rol) > -1 && (
                                                                                <Dropdown.Item onClick={(e:any)=>{cambiarRol(e,usuario,'ROLE_GERENTE')}}> VOLVER GERENTE  </Dropdown.Item>
                                                                              )
                                                                            }



                                                                            {
                                                                              // ['ROLE_ASESOR_BASE','ROLE_ASESOR'].indexOf(usuario.rol) > -1 && (
                                                                              //   <Dropdown.Item onClick={()=>{abrirModalEditarAsesor(usuario)}}>Editar Información  <i className="fa fa-pencil"/></Dropdown.Item>
                                                                              // )
                                                                            }
                                                                            {
                                                                              // ['ROLE_GERENTE','ROLE_GERENTE_JR','ROLE_GERENTE_CONSOLIDADO','ROLE_ASISTENTE'].indexOf(usuario.rol) > -1 && (
                                                                              //   <Dropdown.Item onClick={()=>{abrirModalEditarGerente(usuario)}}> Editar Información <i className="fa fa-pencil"/></Dropdown.Item>
                                                                              // )
                                                                            }
                                                                    </Dropdown.Menu>
                                                                  </Dropdown>
                                                            )
                                                        }


                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>
                                                        <Button onClick={()=>{handleShow_ModalAuditoriaMovimientosPersonal(usuario)}} size="sm"><i className="fa fa-list"/></Button>
                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>
                                                        


                                                                    {
                                                                      (['ROLE_ASESOR_BASE','ROLE_ASESOR','ROLE_GERENTE_JR','ROLE_GERENTE','ROLE_DIRECTOR_COMERCIAL'].indexOf(usuario.rol) < 0 && usuario.activo) && (
                                                                          <>
                                                                            <Button onClick={()=>{handleShow_ModalFaltasRetardos(usuario)}} variant="danger" size="sm"><i className="fa fa-bed"/></Button>
                                                                          </>
                                                                      )
                                                                    }


                                                      </td>
                                                    </tr>
                                                 )
                                              }

                                            </tbody>
                                          </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />




                                          </>



                                         )
                                     }






                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}












                </div>
              </div>

            </div>







        {
          show_ModalAsignarSupervisorAsesor && (
            <ModalAsignarSupervisorAsesor show={show_ModalAsignarSupervisorAsesor} handleClose={handleClose_ModalAsignarSupervisorAsesor} asesor={asesor_editar} />
            )
        }



        {
          show_ModalNuevoSupervisor && (
            <ModalNuevoSupervisor show={show_ModalNuevoSupervisor} handleClose={handleClose_ModalNuevoSupervisor} />
            )

        }


        {
          show_ModalSupervisorListaSupervisados && (
            <ModalSupervisorListaSupervisados show={show_ModalSupervisorListaSupervisados} handleClose={handleClose_ModalSupervisorListaSupervisados} usuario={asesor_editar} />
            )

        }




        {
          show_ModalNuevoDirector && (
            <ModalNuevoDirector show={show_ModalNuevoDirector} handleClose={handleClose_ModalNuevoDirector}  />
            )

        }






        {
          modalNuevoAsesor && (
            <ModalNuevoAsesor show={modalNuevoAsesor} onHide={onHideModalNuevoAsesor} />
          )

        }


        {

          ModalNuevoGerente && (

            <ModalNuevoGerente show={modalNuevoGerente} onHide={onHideModalNuevoGerente} />

          )

        }




        {

          modalNuevoDirectorComercial && (

            <ModalNuevoDirectorComercial show={modalNuevoDirectorComercial} onHide={onHideModalNuevoDirectorComercial}  />

          )

        }


        {

          modalEditarAsesor && (

            <ModalEditarAsesor show={modalEditarAsesor} onHide={onHideModalEditarAsesor} asesor={asesor_editar} />

          )

        }



        {

          modalEditarGerente && (

            <ModalEditarUsuario show={modalEditarGerente} onHide={onHideModalEditarGerente} gerente={gerente_editar} />

          )

        }




        {

          ModalEditarDirectorComercial && (

            <ModalEditarDirectorComercial show={show_ModalEditarDirectorComercial} onHide={handleClose_ModalEditarDirectorComercial} gerente={asesor_editar} />

          )

        }






  {
    show_ModalResetPasswordUsuario && (
      <ModalResetPasswordUsuario show={show_ModalResetPasswordUsuario} handleClose={handleClose_ModalResetPasswordUsuario} usuario={asesor_editar} />
      )

  }


  {
    show_ModalListaAsesoresGerente && (
      <ModalListaAsesoresGerente show={show_ModalListaAsesoresGerente} handleClose={handleClose_ModalListaAsesoresGerente} gerente={asesor_editar} />
      )

  }





  {
    show_ModalSucursalesDirectorComercial && (
      <ModalSucursalesDirectorComercial show={show_ModalSucursalesDirectorComercial} handleClose={handleClose_ModalSucursalesDirectorComercial} director_comercial={asesor_editar} />
      )

  }


  {
    show_ModalCambiarUsername && (
      <ModalCambiarUsername show={show_ModalCambiarUsername} handleClose={handleClose_ModalCambiarUsername} usuario={asesor_editar} />
      )

  }


  {
    show_ModalContratoEmpleado && (
      <ModalContratoEmpleado show={show_ModalContratoEmpleado} handleClose={handleClose_ModalContratoEmpleado} empleado={asesor_editar} />
      )

  }




  {
    show_ModalNuevoAdministrativo && (
      <ModalNuevoAdministrativo show={show_ModalNuevoAdministrativo} handleClose={handleClose_ModalNuevoAdministrativo}  />
      )

  }


  {
    show_ModalNuevoUsuarioContabilidad && (
      <ModalNuevoUsuarioContabilidad show={show_ModalNuevoUsuarioContabilidad} handleClose={handleClose_ModalNuevoUsuarioContabilidad} tipo_contabilidad={tipo_contabilidad} />
      )

  }


  {
    show_ModalMovimientoAdministrativo && (
      <ModalMovimientoAdministrativo show={show_ModalMovimientoAdministrativo} handleClose={handleClose_ModalMovimientoAdministrativo} empleado={asesor_editar}  />
      )

  }



  {
    show_ModalAsesorAsignarGerente && (
      <ModalAsesorAsignarGerente show={show_ModalAsesorAsignarGerente} handleClose={handleClose_ModalAsesorAsignarGerente}  empleado={asesor_editar}  />
      )

  }


  {
    show_ModalAuditoriaMovimientosPersonal && (
      <ModalAuditoriaMovimientosPersonal show={show_ModalAuditoriaMovimientosPersonal} handleClose={handleClose_ModalAuditoriaMovimientosPersonal}  empleado={asesor_editar}  />
      )

  }


  {
    show_ModalFaltasRetardos && (
      <ModalFaltasRetardos show={show_ModalFaltasRetardos} handleClose={handleClose_ModalFaltasRetardos} empleado={asesor_editar} />
      )

  }

  

          </>

      );
  

}

export default RecursosHumanos
